import { useState } from "react";
import { Link } from "react-router-dom";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase/config";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Sparkles, ArrowLeft, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setE] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setL] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setL(true);
    try {
      await sendPasswordResetEmail(auth, email);
      setSent(true);
      toast.success("Reset link sent if email exists");
    } catch (err) {
      if (err?.code === "auth/user-not-found") {
        setSent(true); // Don't reveal whether email exists
      } else {
        toast.error("Something went wrong. Try again.");
      }
    } finally { setL(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 sm:px-6 py-16 sm:py-10 grid-bg">
      <Link to="/" data-testid="back-to-home-btn" className="fixed top-3 left-3 sm:top-6 sm:left-6 z-10 inline-flex items-center gap-1.5 sm:gap-2 px-2.5 sm:px-3.5 py-1.5 sm:py-2 rounded-xl glass hover:bg-white/[0.08] text-xs sm:text-sm text-zinc-300 hover:text-white transition-colors">
        <ArrowLeft size={12} className="sm:w-3.5 sm:h-3.5"/> Back to Home
      </Link>
      <div className="w-full max-w-sm sm:max-w-md glass-strong rounded-2xl sm:rounded-3xl p-5 sm:p-8 animate-fade-up">
        <Link to="/" className="flex items-center gap-2 mb-6">
          <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-indigo-500 to-cyan-500 flex items-center justify-center"><Sparkles size={18}/></div>
          <div className="font-bold text-lg" style={{fontFamily:"'Cabinet Grotesk', sans-serif"}}>HumanizeAI</div>
        </Link>
        <h1 className="text-3xl font-bold tracking-tight" style={{fontFamily:"'Cabinet Grotesk', sans-serif"}}>Reset password</h1>
        <p className="text-sm text-zinc-400 mt-1">We'll email you a reset link.</p>
        {sent ? (
          <div className="mt-6 glass rounded-xl p-4 text-sm text-emerald-300">
            If <b>{email}</b> is registered, we just sent a reset link. Check your inbox.
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label className="text-xs uppercase tracking-widest text-zinc-400">Email</Label>
              <Input data-testid="forgot-email" value={email} onChange={e=>setE(e.target.value)} type="email" required className="mt-1.5"/>
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-indigo-600 hover:bg-indigo-700 h-11" data-testid="forgot-submit-btn">
              {loading ? <Loader2 className="animate-spin" size={16}/> : "Send reset link"}
            </Button>
          </form>
        )}
        <Link to="/login" className="mt-6 inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white">
          <ArrowLeft size={14}/> Back to login
        </Link>
      </div>
    </div>
  );
}
